module.exports = __webpack_public_path__ + "img/icon_map_199_off_101.90a0febb.png";